<template>
    <div class="Momenta">
        <div class="Momenta__container">
            <div class="Momenta__header">
                <div class="Momenta__title" v-html="trans('PAGES.MOMENTA.title')"/>
                <div class="Momenta__subtitle">{{ trans('PAGES.MOMENTA.texte') }}</div>
            </div>
            <div class="Momenta__desc"> 
                <div v-html="trans('PAGES.MOMENTA.description')" /> 
                <div class="Artwork__title-1">{{ trans('PAGES.MOMENTA.artistes')}}</div>
                <ul>
                    <li>Frances Adair Mckenzie</li>
                    <li>alaska B</li>
                    <li>Scott Benesiinaabandan</li>
                    <li>Anna Binta Diallo</li>
                    <li>Maryse Goudreau</li>
                    <li>Ts̱ēmā Igharas</li>
                    <li>Lisa Jackson</li>
                    <li>Kama La Mackerel</li>
                    <li>Malik McKoy</li>
                    <li>Alex McLeod</li>
                    <li>Sabrina Ratté</li>
                </ul>
                <div class="Artwork__title-1">{{ trans('PAGES.MOMENTA.specs')}}</div>
                <div v-html="trans('PAGES.MOMENTA.specs_desc')" /> 
            </div>       
        </div>  
        <div class="Momenta__arrow">
            <div ref="back" class="Complements__back white" @click="callBack()">
                <img :src="require('@/commons/img/back.png')">
            </div>
        </div>
    </div>
</template>

<script>

import gsap from "gsap"

export default {
    name: 'Momenta',
    data: ()=>({
    }),
    beforeCreate() {
        window.scrollTo(0,0)
    },
    mounted() {
        gsap.from(this.$refs.back, { duration: .35, x: 30, delay: .2, alpha: 0 })
    },
    methods: { 
        callBack() {
            gsap.delayedCall(.15, ()=>{ this.$parent.step = 'left' })
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Momenta 

    display flex
    position absolute 
    width 100vw
    top 0

    &__arrow
        position fixed
        width 100%
   
    &__container
        display flex
        align-items flex-center
        justify-content center
        flex-direction column
        padding 36px 30px 208px
        width 100%

    &__header
        display flex
        flex-direction column
        width 100%
        padding-bottom 48px

    &__title 
        font-weight 800
        font-size 22px
        text-align center
        line-height 24px
        text-transform uppercase
        padding-bottom 8px

        &-sub 
            font-weight 700

    &__subtitle 
        text-align center
        font-size 16px
        text-transform uppercase

    &__groupe
        font-weight 700
        padding 8px 0 32px
        font-size 18px
        line-height 20px

    &__desc 
        display flex
        align-items flex-center
        justify-content center
        flex-direction column
        text-align left
        font-weight 200
        font-size 16px

    &__sub
        padding-bottom 32px
        font-size 16px

    ul
        padding 0 0 0 32px
        list-style-image url('./img/line.png')
        list-style-position outside
      
        li
            font-family Ringside
            font-size 16px
            font-weight 200
            padding 0 0 16px 8px

         
</style>














